import React from "react";
import { Link } from "react-router-dom";
import { useContent } from "@/context/ContentContext";

export default function About() {
    const c = useContent();
    const a = c.about_page || {};
    return (
        <div>
            <section className="relative min-h-[50vh] flex items-end overflow-hidden">
                <img src={a.hero_image_url} alt="Umami Kraft interior" className="absolute inset-0 w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-ink via-brand-ink/70 to-brand-ink/20" />
                <div className="container-wide relative z-10 py-16">
                    <p className="font-script text-brand-gold text-3xl">{a.script}</p>
                    <h1 className="font-display text-5xl md:text-6xl mt-1 text-brand-cream max-w-3xl leading-tight">
                        {a.title_line1}<br />{a.title_line2}
                    </h1>
                </div>
            </section>

            <section className="container-wide py-20 grid md:grid-cols-2 gap-16">
                <div className="space-y-6">
                    {(a.paragraphs || []).map((p, i) => (
                        <p key={i} className="text-brand-cream/90 leading-relaxed text-lg">{p}</p>
                    ))}
                </div>
                <div className="border-l border-brand-line pl-10 space-y-8">
                    {(a.highlights || []).map((h, i) => (
                        <div key={i}>
                            <p className="font-script text-brand-gold text-2xl">{h.title}</p>
                            <p className="text-brand-cream/80 mt-1">{h.body}</p>
                        </div>
                    ))}
                    <Link to="/order" className="btn-outline mt-4">{a.cta || "Explore our menu"}</Link>
                </div>
            </section>
        </div>
    );
}
